import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { LoadingService } from '@serpro/ngx-suite-rfb';
import { AmbienteService } from 'src/app/shared/services/ambiente.service';
import { AtoService } from 'src/app/shared/services/ato.service';
import { Ambiente } from 'src/app/shared/model/ambiente.model';
import { ArquivoBinario } from 'src/app/shared/model/arquivo-binario.model';
import { ArvoreEstilos } from 'src/app/shared/model/arvore-estilos.model';
import { Assunto } from 'src/app/shared/model/assunto.model';
import { EstiloSegmento } from 'src/app/shared/model/estilo-segmento.model';
import { SegmentoTela } from 'src/app/shared/model/segmento.model';
import { CONSULTA_ADMIN } from 'src/app/shared/model/tipo-consulta.model';
import { TipoSegmento } from 'src/app/shared/model/tipo-segmento.model';
import { Base64 } from 'src/app/shared/util/base64.util';
import Quill, { DeltaStatic } from 'quill';
import { Focus } from 'ngx-quill';
import { fromEvent, throttleTime } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-editar-conteudo-ato',
    templateUrl: './editar-conteudo-ato.component.html',
    styleUrls: ['./editar-conteudo-ato.component.css']
})
export class EditarConteudoAtoComponent implements OnInit {
    @Input() segmentos: SegmentoTela[];
    @Input() tiposSegmento: TipoSegmento[];
    @Input() assuntos: Assunto[];
    @Input() assuntoGlobal: Assunto;
    @Input() fullscreen = false;
    @Input() readonly = false;
    @Input() tituloPagina: string;
    @Output() salvar: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild('inputFileAnexo') inputFileAnexo: ElementRef;
    @ViewChild('conteudoAto2') conteudoAto2: ElementRef;

    ambiente: Ambiente

    tipoSegmentoGlobal: TipoSegmento;
    tipoSegmento: TipoSegmento;
    tipo: string;
    idAssunto: number;
    currentSegment = -1;
    currentSegmentBackup = -1;
    pos1: number;
    pos2: number;
    posY0: number;
    posX0: number;
    dragging = false;

    exibirModalAddLink = false;
    addLinkUrl = '';
    erroModal = '';

    exibirConfeccionarLUDs = false;
    segmentosParaLUDs: SegmentoTela[] = [];

    exibirModalEstiloSegmento = false;
    estiloSegmento: EstiloSegmento;
    segmentoSelecionado: SegmentoTela;

    pleaseFocusOnMe: number|null = null;
    isAnexo: boolean;
    changeFileAnexo: boolean;
    idArquivoBinario: number|undefined;
    arquivoBinario: ArquivoBinario|undefined;
    conteudoArquivoBinario: string|null = null;
    tipoArquivoBinario: number|null = null;

    exibirModalAlerta = false;
    mensagemAlerta: string;

    arvoreEstilos: ArvoreEstilos;
    tiposSegmentoFiltrados: TipoSegmento[];

    toolbarOpened: boolean[] = [false, false, false];

    fontFamilies: {texto: string, valor: string | false}[] = [
        { texto: 'sans-serif', valor: false},
        { texto: 'serif', valor: 'serif'},
        { texto: 'monospace', valor: 'monospace'},
    ];

    fontSizes: {texto: string, valor: string | false}[] = [
        { texto: 'menor', valor: 'small'},
        { texto: 'normal', valor: false},
        { texto: 'maior', valor: 'large'},
        { texto: 'gigante', valor: 'huge'},
    ];

    fontColors: {texto: string, valor: string | false}[] = [
        { texto: 'black', valor: 'black'},
        { texto: 'dimgray', valor: 'dimgray'},
        { texto: 'gray', valor: 'gray'},
        { texto: 'red', valor: 'red'},
        { texto: 'fuchsia', valor: 'fuchsia'},
        { texto: 'purple', valor: 'purple'},
        { texto: 'darkblue', valor: 'darkblue'},
        { texto: 'mediumblue', valor: 'mediumblue'},
        { texto: 'royalblue', valor: 'royalblue'},
        { texto: 'green', valor: 'green'},
    ];

    constructor(
        private atoService: AtoService,
        private loadingService: LoadingService,
        private readonly ambienteService: AmbienteService,
        private ngZone: NgZone,
        private readonly sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        // na edição de segmento no gerir-anotacoes, é interessanet focar no segmento
        if (this.segmentos.length == 1) {
            this.onFocusEditor(null, 0);
        }
        this.arvoreEstilos = new ArvoreEstilos(this.tiposSegmento);
        this.tiposSegmentoFiltrados = this.tiposSegmento
            .filter((i) => i.idTipoSegmento != 0 && i.idTipoSegmento != 16)
            .sort((a, b) => (a.nomeTipoSegmento > b.nomeTipoSegmento ? 1 : -1));

        for (const s of this.segmentos) {
            this.definirEstilo(s);
            if (
                (s.arquivoBinario && s.idTipoSegmento !== 16) ||
                (!s.arquivoBinario && s.idTipoSegmento === 16)
            ) {
                s.anexoInconsistente = true;
            }
        }
        this.ambienteService.getAmbiente().subscribe({
            next: (ambiente: Ambiente) => {
                this.ambiente = ambiente;
            },
            error: () => null
        });
        setTimeout(() => {
            this.prepareDebouncingScrollConteudoAto();
            this.ajustarSegmentosVisiveisNoContainer();
        }, 5000);
    }

    definirEstilo(segmento: SegmentoTela) {
        if (segmento.estiloSegmento) {
            const no = this.arvoreEstilos.incluirNoSegmento(segmento.idTipoSegmento, segmento.estiloSegmento);
            segmento.style = no?.getStyle(true);
        } else {
            segmento.style = this.arvoreEstilos.getStyle(segmento.idTipoSegmento, true);
        }
    }

    /**
     * Sanitiza o conteúdo HTML de um segmento de tabela para garantir que o estilo próprio da tabela seja aplicado.
     * Este método decodifica o conteúdo do arquivo binário codificado em base64 e o sanitiza usando o DomSanitizer do Angular.
     * O HTML sanitizado é então armazenado na propriedade `innerHTMLSanitizado` do segmento.
     *
     * @param segmento - O segmento contendo a tabela cujo conteúdo HTML precisa ser sanitizado.
     * @returns O conteúdo HTML sanitizado como um objeto SafeHtml.
     */
    public getInnerHtmlTabela(segmento: SegmentoTela): SafeHtml {
        if (segmento.arquivoBinario.arquivoBinario) {
            if (!segmento.innerHTMLSanitizado) {
                segmento.innerHTMLSanitizado = this.sanitizer.bypassSecurityTrustHtml(Base64.decode(segmento.arquivoBinario.arquivoBinario));
            }        
            return segmento.innerHTMLSanitizado;
        }        
        return segmento.innerHTML;
    }

    /**
     * Obtém o editor Quill selecionado, além da posição do cursor e do tamanho da seleção
     * @returns { editor selecionado, posicao do cursor, tamanho da seleção }
     */
    private getEditorSelecionado(): CurrentEditor | null {
        const retorno = new CurrentEditor();
        const i = this.currentSegment;
        if (i >= 0 && i < this.segmentos.length) {
            const quill = this.segmentos[i].editor;
            if (quill) {
                retorno.quill = quill;
                const range = retorno.quill.getSelection(true);
                if (range) {
                    retorno.index = range.index;
                    retorno.length = range.length;
                }
                return retorno;
            }
        }
        return null;
    }

    public format(formato: string) {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;
            if (quill.getFormat()[formato]) {
                quill.format(formato, false);
            } else {
                quill.format(formato, true);
            }
            this.ajustarTextoIntegra(quill);
            setTimeout(() => 
                quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
        }
    }

    public formatText(formato: string) {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;
            if (quill.getFormat()['script'] == formato) {
                quill.format('script', false);
            } else {
                quill.formatText(editorSelecionado.index, editorSelecionado.length, 'script', formato);
            }
            this.ajustarTextoIntegra(quill);
            setTimeout(() => 
                quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
        }
    }

    public removeFormat() {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;
            quill.removeFormat(editorSelecionado.index, editorSelecionado.length);
            this.ajustarTextoIntegra(quill);
        }
    }

    public formatFontFamily(i: number) {
        this.closeAllToolbars();
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const font = this.fontFamilies[i].valor;
            this.formatFontFamilyTo(font, editorSelecionado);
        }
    }

    private formatFontFamilyTo(font: string | false, editorSelecionado: CurrentEditor) {
        const quill = editorSelecionado.quill;
        quill.format('font', font);
        this.ajustarTextoIntegra(quill);
        setTimeout(() => 
            quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
    }

    formatFontSize(i: number) {
        this.closeAllToolbars();
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const size = this.fontSizes[i].valor;
            this.formatFontSizeTo(size, editorSelecionado);
        }
    }

    private formatFontSizeTo(size: string | false, editorSelecionado: CurrentEditor) {
            const quill = editorSelecionado.quill;
            quill.format('size', size);
            this.ajustarTextoIntegra(quill);
            setTimeout(() => 
                quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
    }

    formatFontColor(i: number) {
        this.closeAllToolbars();
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const color = this.fontColors[i].valor;
            this.formatFontColorTo(color, editorSelecionado);
        }
    }

    private formatFontColorTo(color: string | false, editorSelecionado: CurrentEditor) {
        const quill = editorSelecionado.quill;
        quill.format('color', color);
        this.ajustarTextoIntegra(quill);
        setTimeout(() => 
            quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public formatAddLink(event: MouseEvent) {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;
            quill.format('background-color', 'royalblue');
            quill.format('color', 'white');
            // const [leaf, offset] = editor.getLeaf(range.index + 1);
            const [leaf] = quill.getLeaf(editorSelecionado.index + 1);
            this.addLinkUrl = '';
            this.erroModal = '';
            if (leaf.parent.domNode.tagName == 'A') {
                this.addLinkUrl = leaf.parent.domNode.getAttribute('href');
            }
            this.exibirModalAddLink = true;
            document.getElementById('url')?.focus();
            setTimeout(() => 
                document.getElementById('url')?.focus(), 10);
        }
    }

    public keyupUrl(e: KeyboardEvent) {
        if (e.code == "Enter" || e.key == 'Enter') {
            this.confirmarAddLink();
            e.preventDefault();
            return false;
        }
        return true;
    }

    public confirmarAddLink() {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;

            // Aqui há uma mágica:
            // O texto selecionado foi formatado anteriormente no método formatAddLink()
            // É necessário fazer o undo() antes de aplicar a tag <a> do link, pois senão
            // no CTRL+Z (undo) esta formatação é recuperada, deixando o texto como seleção azul.
            // Foi necessário criar uma interface Fake porque o typescript não reconheceu o history.
            // E com o undo() a seleção precisou ser redefinida....
    
            const x = quill as unknown as FakeQuill;
            x.history.undo();
            quill.setSelection(editorSelecionado.index, editorSelecionado.length);
            
            this.addLinkUrl = this.addLinkUrl.trim();
            let url = this.addLinkUrl;
            if (url.indexOf('://') < 0) {
                url = 'http://' + url;
            }
            const [leaf] = quill.getLeaf(editorSelecionado.index + 1);
            if (leaf.parent.domNode.tagName == 'A') {
                leaf.parent.domNode.setAttribute('href', url);
            } else {
                quill.format('link', url);
            }
    
            this.ajustarTextoIntegra(quill);
            let limpo = this.segmentos[this.currentSegment].textoIntegra;
            limpo = limpo.replace(' target="_blank"', '');
            this.segmentos[this.currentSegment].textoIntegra = limpo;
            this.exibirModalAddLink = false;
            setTimeout(() => 
                quill.setSelection(editorSelecionado.index, editorSelecionado.length), 10);
            quill.focus();
        }
    }

    public cancelarAddLink() {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length > 0) {
            const quill = editorSelecionado.quill;
            quill.format('background-color', false);
            quill.format('color', false);
            this.exibirModalAddLink = false
        }
    }

    public formatRemoveLink() {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.length >= 0) {
            const quill = editorSelecionado.quill;
            const [leaf, offset] = quill.getLeaf(editorSelecionado.index + 1);
            if (leaf.parent.domNode.tagName == 'A') {
                const start = editorSelecionado.index - offset + 1;
                quill.setSelection(start, leaf.text.length);
                quill.format('link', false);
                this.ajustarTextoIntegra(quill);
            }
        }
    }

    public formatAddSegment() {
        let i = 0;
        if (this.segmentos.length > 0) {
            i = this.currentSegment;
            if (i < 0) {
                return;
            }
            if (i < this.segmentos.length - 1) {
                if (this.segmentos[i].idSegmento != null
                        && this.segmentos[i].idSegmento == this.segmentos[i+1].idSegmento) {
                    this.mensagemAlerta = 'Não é permitido incluir um novo segmento entre versões de um mesmo segmento.';
                    this.exibirModalAlerta = true;
                    return;
                }
            }
        }
        const novo = new SegmentoTela();
        novo.visivel = true;
        novo.idAssunto = this.assuntoGlobal.idAssunto;
        this.segmentos.splice(i+1, 0, novo);
        this.currentSegment++;
        this.pleaseFocusOnMe = this.currentSegment;
    }

    public formatRemoveSegment() {
        const i = this.currentSegment;
        if (i < 0) {
            return;
        }
        const segmento = this.segmentos[i];
        if (segmento.versionado) {
            this.mensagemAlerta = 'Um segmento versionado não pode ser excluído.';
            this.exibirModalAlerta = true;
            return;
        }
        if (segmento.anotado) {
            this.mensagemAlerta = 'Um segmento anotado não pode ser excluído.';
            this.exibirModalAlerta = true;
            return;
        }
        if (i >= 0 && i < this.segmentos.length) {
            this.segmentos.splice(i, 1);
            if (this.currentSegment >= this.segmentos.length) {
                this.currentSegment = this.segmentos.length-1;
            }
            this.ajustarTipoEAssunto();
        }
    }

    public formatEstiloSegmento() {
        const i = this.currentSegment;
        if (i < 0) {
            return;
        }
        this.currentSegmentBackup = this.currentSegment;
        this.currentSegment = -1;
        const segmento = this.segmentos[i];
        let tipoSegmento = this.tiposSegmento.find(i => segmento.idTipoSegmento == i.idTipoSegmento);
        if (!tipoSegmento || tipoSegmento.idTipoSegmento === 16) {
            return;
        }
        this.tipoSegmento = tipoSegmento;
        tipoSegmento = this.tiposSegmento.find(i => 0 == i.idTipoSegmento);
        if (!tipoSegmento) {
            return;
        }
        this.segmentoSelecionado = segmento;
        this.tipoSegmentoGlobal = tipoSegmento;
        this.abrirModalEstiloSegmento();
    }

    abrirModalEstiloSegmento() {
        document.body.style.overflowY = 'hidden';
        this.exibirModalEstiloSegmento = true;
    }

    fecharModalEstiloSegmento() {
        document.body.style.overflowY = 'auto';
        this.exibirModalEstiloSegmento = false;
    }

    public aplicarEstilo(estiloSegmento: EstiloSegmento | null) {
        this.currentSegment = this.currentSegmentBackup;
        this.currentSegmentBackup = -1;

        if (estiloSegmento) {
            this.segmentoSelecionado.estiloSegmento = estiloSegmento;
            this.definirEstilo(this.segmentoSelecionado);
        }
        this.fecharModalEstiloSegmento();
    }

    public onFocusEditor(event: Focus | null, idx: number) {
        this.currentSegment = idx;
        this.ajustarTipoEAssunto();
    }

    private ajustarTipoEAssunto() {
        this.tipo = '' + this.segmentos[this.currentSegment].idTipoSegmento;
        this.idAssunto = this.segmentos[this.currentSegment].idAssunto;
    }

    public changeTipoSegmento() {
        if (this.currentSegment >= 0) {
            const idSelecionado = parseInt(this.tipo);
            const index = this.tiposSegmento.find(i => idSelecionado == i.idTipoSegmento);
            const segmento = this.segmentos[this.currentSegment];
            if (index) {
                segmento.idTipoSegmento = parseInt(this.tipo);
                this.definirEstilo(segmento);
            }
        }
    }

    public changeAssunto() {
        if (this.currentSegment >= 0) {
            const assunto = this.assuntos.find(i => this.idAssunto == i.idAssunto);
            const segmento = this.segmentos[this.currentSegment];
            if (assunto) {
                segmento.idAssunto = assunto.idAssunto;
            }
        }
    }

    public paste(event: ClipboardEvent) {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.index >= 0) {
            const quill = editorSelecionado.quill;
            if (event.clipboardData) {
                event.preventDefault();
                let data = event.clipboardData.getData('text');
                while(data.indexOf('\n\n') >= 0) {
                    data = data.replace('\n\n', '\n');
                }
                while(data.indexOf(' \n') >= 0) {
                    data = data.replace(' \n', '\n');
                }
                quill.insertText(editorSelecionado.index + editorSelecionado.length, data);
                this.ajustarTextoIntegra(quill);
                setTimeout(() => 
                    quill.setSelection(editorSelecionado.index + data.length, 0), 10);
            }
        }
    }

    public keyUpEditor(e: KeyboardEvent) {
        if (e.code == "Delete" || e.key == 'Delete') {
            // DEL com o cursor no fim do texto copia o segmento seguinte no segmento atual
            if (e.shiftKey) {
                return this.juntaSegmento();
            } else {
                return true;
            }
        }
        if (e.code == "Enter" || e.key == 'Enter') {
            // ENTER divide o segmento atual em dois segmentos
            if (e.shiftKey) {
                return true;
            } else {
                const retorno = this.separaSegmento();
                if (!retorno) {
                    const editorSelecionado = this.getEditorSelecionado();
                    if (editorSelecionado) {
                        const quill = editorSelecionado.quill;
    
                        // ver comentários no método confirmarAddLink()
                        const x = quill as unknown as FakeQuill;
                        x.history.undo();
                    }
                }
                return false;
            }
        }
        return true;
    }

    private juntaSegmento(): boolean {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.index >= 0) {
            const quill = editorSelecionado.quill;
            const i = this.currentSegment;
            const segmentoAtual = this.segmentos[i];
            const segmentoSeguinte = this.segmentos[i+1];
    
            if (i >= this.segmentos.length - 1) {
                return false;
            }
            if (segmentoAtual.versionado || segmentoSeguinte.versionado) {
                return false;
            }
            if (segmentoAtual.anotado || segmentoSeguinte.anotado) {
                return false;
            }
            if (segmentoSeguinte.idTipoSegmento == 16) {
                return false; // segmento com anexo
            }
    
            if (editorSelecionado.index == quill.getText().length - 1) {
                const index = quill.getSelection()?.index;
                segmentoAtual.textoIntegra = segmentoAtual?.textoIntegra + segmentoSeguinte?.textoIntegra;
                
                this.segmentos.splice(i + 1, 1);
                setTimeout(() => 
                    quill.setSelection(index ? index:0, 0), 10)
                return false;
            }
        }
        return true;
    }

    private separaSegmento(): boolean {
        const editorSelecionado = this.getEditorSelecionado();
        if (editorSelecionado && editorSelecionado.index > 0) {
            const quill = editorSelecionado.quill;
            const i = this.currentSegment;
            const segmentoAtual = this.segmentos[i];
            if (!segmentoAtual.versionado && !segmentoAtual.anotado) {
                const delta = quill.getContents(editorSelecionado.index, quill.getText().length);
                const html = this.getHTMLFromDelta(delta);
                const novo = new SegmentoTela();
                novo.textoIntegra = html;
                novo.idAssunto = this.assuntoGlobal.idAssunto;
                quill.deleteText(editorSelecionado.index, quill.getText().length);
                this.ajustarTextoIntegra(quill);
                this.segmentos.splice(this.currentSegment+1, 0, novo);
                novo.visivel = true;
                this.pleaseFocusOnMe = this.currentSegment + 1;
                return true;
            }
        }
        return false;
    }

    private getHTMLFromDelta(delta: DeltaStatic) {
        const tempQuill = new Quill(document.createElement('div'));
        tempQuill.setContents(delta);
        return tempQuill.root.innerHTML;
    }

    public onEditorCreated(editor: Quill, idx: number) {     
        const segmento = this.segmentos[idx];
        if (!segmento.arquivoBinario) {
            segmento.editor = editor;
        }

        if (this.pleaseFocusOnMe === idx) {
            this.pleaseFocusOnMe = null;
            segmento.editor?.focus();
        }
    }

    private ajustarTextoIntegra(editor: Quill) {
        this.segmentos[this.currentSegment].textoIntegra = editor.root.innerHTML;
    }

    public toolboxIncluirAnexo() {
        const i = this.currentSegment;
        if (i < 0) {
            return;
        }
        if (i < this.segmentos.length - 1
                && this.segmentos[i].idSegmento != null
                && this.segmentos[i].idSegmento == this.segmentos[i+1].idSegmento) {
            this.mensagemAlerta = 'Não é permitido incluir um novo segmento entre versões de um mesmo segmento.';
            this.exibirModalAlerta = true;
            return;
        }

        this.changeFileAnexo = false;
        this.inputFileAnexo.nativeElement.click();
    }

    public toolboxSubstituirAnexo() {
        const i = this.currentSegment;
        if (i < 0) {
            return;
        }
        this.changeFileAnexo = true;
        this.inputFileAnexo.nativeElement.click();
    }

    public onFileChange(event: Event) {
        this.arquivoBinario = undefined;
        this.idArquivoBinario = undefined;
        this.conteudoArquivoBinario = null;
        this.tipoArquivoBinario = null;

        const i = this.currentSegment;
        if (i < 0 || i >= this.segmentos.length) {
            return;
        }
        const target = event.target as HTMLInputElement;
        const files = target.files as FileList;
        const fileAnexo = files[0];
        target.value = '';
        if (fileAnexo.size > 40 * 1000 * 1000) {
            this.mensagemAlerta = 'O arquivo excede o tamanho máximo de 40.000.000 bytes.';
            this.exibirModalAlerta = true;
            return;
        }

        const tipo = fileAnexo.name.split('.').pop();
        if (tipo) {
            const j = ['jpg','jpeg','gif','htm','html','pdf','doc','xls','ppt','pps','docx','xlsx','pptx','ppsx','odt','stw','ods','odp'].indexOf(tipo.toLowerCase());
            if (j >= 0) {
                this.tipoArquivoBinario = [2,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18][j];
            }
        }
        if (this.tipoArquivoBinario == null) {
            this.mensagemAlerta = 'A extensão de arquivo "' + tipo + '" não é permitida para anexos.';
            this.exibirModalAlerta = true;
            return;
        }
        this.loadingService.show();

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const me = this;

        this.atoService.uploadAnexo(fileAnexo).subscribe({  
            next: (retorno: ArquivoBinario) => {
                if (retorno.mensagemErro) {
                    this.mensagemAlerta = retorno.mensagemErro;
                    this.exibirModalAlerta = true;
                } else {
                    this.arquivoBinario = retorno;
                    this.idArquivoBinario = retorno.idArquivoBinario;
                    this.confirmarAnexo();
                }
                this.loadingService.hide();
            },
            error: () => this.loadingService.hide()
        });
        const r = new FileReader();
        r.onload = function() {
            if (typeof r.result === 'string') {
                me.conteudoArquivoBinario = r.result.split(',')[1];
            }
        }
        r.readAsDataURL(fileAnexo);
    }

    public confirmarAnexo() {
        const i = this.currentSegment;
        let segmento = this.segmentos[this.currentSegment];
        if (!this.changeFileAnexo) {
            segmento = new SegmentoTela();
            this.segmentos.splice(i+1, 0, segmento);
            this.currentSegment++;
        }
        this.tipo = '16';
        if (this.tipoArquivoBinario != null && this.arquivoBinario) {
            segmento.idTipoSegmento = 16;
            segmento.arquivoBinario = this.arquivoBinario;
            if (this.conteudoArquivoBinario != null) {
                if ([2,3].indexOf(this.tipoArquivoBinario) >= 0) {
                    segmento.arquivoBinario.arquivoBinario = this.conteudoArquivoBinario;
                } else if ([4,5].indexOf(this.tipoArquivoBinario) >= 0) {
                    segmento.innerHTML = Base64.decode(this.conteudoArquivoBinario);
                    segmento.arquivoBinario.arquivoBinario = this.conteudoArquivoBinario;
                }
            }
            if (segmento.anexoInconsistente) {
                segmento.anexoInconsistente = false;
                segmento.idTipoSegmento = 16;
            }
            this.definirEstilo(segmento);
        }
        setTimeout(() => 
            document.getElementById("input-invisivel")?.focus(), 10);
    }

    public baixarAnexo(segmento: SegmentoTela) {
        if (segmento.arquivoBinario.idArquivoBinario) {
            const idAnexo = segmento.arquivoBinario.idArquivoBinario
            this.atoService.downloadAnexoAto(segmento.arquivoBinario.nomeArquivoBinario, 0, idAnexo, CONSULTA_ADMIN);
        }
    }

    clickSalvar() {
        this.fullscreen = false;
        this.salvar.emit(1);
    }

    clickCancelar() {
        this.fullscreen = false;
    }

    borderStyle(segmento: SegmentoTela) {
        if (segmento.versionado || segmento.anotado) {
            return {'border-left':'3px solid rgb(250,45,208)', 'padding-left': '9px'};
        }
        return {'padding-left': '12px'}
    }

    classeEditor(idx: number, segmento: SegmentoTela): string {
        const corTexto = segmento.compilado ? (segmento.original ? '' : ' textoAzul') : ' textoVermelho';
        let corFundo = "";
        if (segmento.anexoInconsistente) {
            corFundo = ' fundo-vermelho';
        }
        if (idx == this.currentSegment) {
            return 'editorSelecionado' + corTexto + corFundo;
        } else {
            return 'editorNaoSelecionado' + corTexto + corFundo;
        }
    }

    abrirConfeccaoLUDs() {
        this.segmentosParaLUDs = [];
        for (const s of this.segmentos) {
            const novo = new SegmentoTela();
            if (s.arquivoBinario) {
                novo.textoIntegra = s.arquivoBinario.nomeArquivoBinario;
            } else {
                novo.textoIntegra = s.textoIntegra;
            }
            novo.style = s.style;
            novo.idTipoSegmento = s.idTipoSegmento;
            this.segmentosParaLUDs.push(novo);
        }
        this.exibirConfeccionarLUDs = true;
        document.body.style.overflowY = 'hidden';
    }
    
    fecharConfeccaoLUDs(novosSegmentos: SegmentoTela[] | null) {
        if (novosSegmentos != null) {
            this.segmentos.forEach((antigo, index) => {
                const novo = novosSegmentos[index];
                if (antigo.idTipoSegmento != 16) {
                    antigo.textoIntegra = novo.textoIntegra;
                }
            });
        }
        this.exibirConfeccionarLUDs = false
        document.body.style.overflowY = 'auto';
    }

    openToolbar(i: number) {
        for (let j = 0; j < this.toolbarOpened.length; j++) {
            this.toolbarOpened[j] = j === i;
        }
    }

    closeAllToolbars() {
        for (let j = 0; j < this.toolbarOpened.length; j++) {
            this.toolbarOpened[j] = false;
        }
    }

    toolbarMouseOver(event: MouseEvent) {
        event.stopPropagation();        
    }

    /**
     * Prepara o evento de Scroll do conteudoAto para que se evitem muitos eventos por segundo (debouncing).
     * Sem isso, a performance do navegador pode ser prejudicada.
     */
    private prepareDebouncingScrollConteudoAto() {
        this.ngZone.runOutsideAngular(() => {
            fromEvent(this.conteudoAto2.nativeElement, 'scroll')
                .pipe(throttleTime(200)) // Throttle de 200ms
                .subscribe(() => {
                    this.ngZone.run(() => {
                        this.scrollConteudoAto();
                    });
                });
        });
    }

    /**
     * Quando se faz scroll no conteúdo do ato, ajusta os componentes Quill que devem ser instanciados ou removidos.
     */
    public scrollConteudoAto() {
        setTimeout(() => {
            this.ajustarSegmentosVisiveisNoContainer();
        }, 300);
    }

    /**
     * A aplicação necessita reduzir o número de componentes Quill ativos para melhorar a performance.
     * Esta função verifica se o segmento está visível no container. Se não estiver, remove (ou não instancia) o editor.
     */
    private ajustarSegmentosVisiveisNoContainer() {
        const container = document.getElementById('conteudoAto2') as HTMLDivElement;
        this.segmentos.forEach((s, idx) => {
            s.visivel = this.segmentoEstaVisivel(document.getElementById('segmento' + idx) as HTMLDivElement, container, 50);
            if (!s.visivel && s.editor) {
                s.editor = null;
            }
        });
    }

    /**
     * Esta função verifica se o segmento está visível no container.
     * @param divSegmento
     * @param divContainer 
     * @param folga pixels de folga para considerar o segmento visível
     * @returns boolean
     */
    private segmentoEstaVisivel(divSegmento: HTMLDivElement, divContainer: HTMLDivElement, folga: number): boolean {
        if (divSegmento && divContainer) {
            const segmentoRect = divSegmento.getBoundingClientRect();
            const containerRect = divContainer.getBoundingClientRect();
            return (
                segmentoRect.top < containerRect.bottom + folga &&
                segmentoRect.bottom > containerRect.top - folga
            );
        }
        return false;
    }



    /**
     * Esses métodos são utilizados para manipular anexos em segmentos de tipo inconsistente.
     */
    uploadAnexoParaSegmentoDeTipoInconsistente(idx: number) {
        const segmento = this.segmentos[idx];
        segmento.editor?.focus();
        setTimeout(() => {
            this.toolboxSubstituirAnexo();
        }, 100);
    }

    trocarTipoSegmentoInconsistenteParaTipoOrdinario(segmento: SegmentoTela) {
        segmento.idTipoSegmento = 999;
        this.tipo = segmento.idTipoSegmento.toString();
        segmento.anexoInconsistente = false;
        setTimeout(() => {
            this.definirEstilo(segmento);
            segmento.editor?.focus();
        }, 100);
    }
    
    trocarTipoSegmentoInconsistenteParaAnexo(segmento: SegmentoTela) {
        segmento.idTipoSegmento = 16;
        segmento.anexoInconsistente = false;
        setTimeout(() => {
            this.definirEstilo(segmento);
            segmento.editor?.focus();
        }, 100);
    }
    
    removerAnexoDeSegmentoDeTipoInconsistente(segmento: SegmentoTela) {
        const segmentoSemAnexo: SegmentoTela = Object.assign(
            new SegmentoTela(), 
            {...segmento, arquivoBinario: undefined, anexoInconsistente: false}
        );
        const idx = this.segmentos.indexOf(segmento);
        this.segmentos[idx] = segmentoSemAnexo;
        setTimeout(() => {
            this.segmentos[idx].editor?.focus();
        }, 100);
    }


}


class CurrentEditor  {
    quill: Quill;
    index = -1;                 // cursor não posicionado
    length = -1                 // nenhum texto selecionado
}

// workaround para acessar atributos do Quill (o typescript não está encontrando)
export class FakeQuill {
    history: {
        undo: () => void
    }
    container: {
        offsetTop: number,
        offsetHeight: number
    }
}
